<template>
    <div>
        <navbarreserve/>
        <!--  -->
      <div class=" d-none d-sm-none d-md-block">
       <b-nav justified class="navbg">
        <!--  -->
        <b-nav-item lg router-link :to="{ name: 'Home'}">
          <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav">{{$t('stepnav.st1')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{fecha_salida}}, {{hora_salida}}</h5>
                   <h5 class="navtext">{{fecha_entrega}}, {{hora_entrega}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg >
            <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav text-uppercase">{{$t('stepnav.st2')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{sucursal_salida.nombre_web}}, {{sucursal_salida.ciudad}}</h5>
                   <h5 class="navtext">{{sucursal_entrega.nombre_web}}, {{sucursal_entrega.ciudad}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg  router-link :to="{ name: 'Reservestep3'}">
            <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav">{{$t('stepnav.st3')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{auto.marca}} {{auto.modelo}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg disabled>
          <div class="mt-3 mb-2 ">
            <div>
              <svg height="20" width="20">
              <circle cx="10" cy="10" r="8" 
              stroke="#333333" 
              stroke-width="2" fill="none"
              />
              <text x="50%" y="50%" 
              text-anchor="middle" 
              stroke="#333333" 
              stroke-width=".7px"
              dy=".35em"
              class="textcircle"
              >4</text>
            </svg>
            <span class="titlenav ml-1">EXTRAS</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <!-- <span class="dinregular">Seleccionar</span> -->
                   <h4 class="dinregular">{{$t('stepnav.st3_1')}}</h4>
                </b-col>
                <b-col cols="3" class="text-right">
                   <!-- <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg> -->
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
      </b-nav> 
      </div>
      
      <!-- navsteps mobile-->
      <b-button 
      block 
      squared 
      v-b-toggle.collapse-steps2
      class="text-left stepscollapse d-md-none d-lg-none d-xl-none ">{{$t('stepnav.det')}}
      <img src="/img/arrowdown.png" class="mt-2" style="float:right;">
      </b-button>
      <b-collapse id="collapse-steps2" class="mt-2">
        <b-nav justified vertical class="navbg">
        <!--  -->
        <b-nav-item lg router-link :to="{ name: 'Home'}">
          <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav">{{$t('stepnav.st1')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{fecha_salida}}, {{hora_salida}}</h5>
                   <h5 class="navtext">{{fecha_entrega}}, {{hora_entrega}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg >
            <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav text-uppercase">{{$t('stepnav.st2')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{sucursal_salida.nombre_web}}, {{sucursal_salida.ciudad}}</h5>
                   <h5 class="navtext">{{sucursal_entrega.nombre_web}}, {{sucursal_entrega.ciudad}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg  router-link :to="{ name: 'Reservestep3'}">
            <div class="mt-3 mb-2 ">
            <div>
              <svg  width="2em" height="1.15em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
              </svg>
            <span class="titlenav">{{$t('stepnav.st3')}}</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <h5 class="navtext">{{auto.marca}} {{auto.modelo}}</h5>
                </b-col>
                <b-col cols="3" class="text-right">
                   <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg>
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
        <!--  -->
        <b-nav-item lg disabled>
          <div class="mt-3 mb-2 ">
            <div>
              <svg height="20" width="20">
              <circle cx="10" cy="10" r="8" 
              stroke="#333333" 
              stroke-width="2" fill="none"
              />
              <text x="50%" y="50%" 
              text-anchor="middle" 
              stroke="#333333" 
              stroke-width=".7px"
              dy=".35em"
              class="textcircle"
              >4</text>
            </svg>
            <span class="titlenav ml-1">EXTRAS</span><br>
            </div>
            <b-row>
                <b-col cols="9" class="text-right">
                   <!-- <span class="dinregular">Seleccionar</span> -->
                   <h4 class="dinregular">{{$t('stepnav.st3_1')}}</h4>
                </b-col>
                <b-col cols="3" class="text-right">
                   <!-- <svg style="" width="3em" height="3em" viewBox="0 4 8 16" class="bi bi-arrow-right-short text-right" fill="#181918" xmlns="http://www.w3.org/2000/svg">
                       <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"/>
                       <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"/>
                   </svg> -->
                </b-col>
            </b-row>
          </div>
        </b-nav-item>
      </b-nav>
      </b-collapse>
      <!--  -->
      <extrascomp/>
      <br>
      <!--  -->
      <mainfooter/>
    </div>
</template>

<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import covidnews      from '@/components/covidnews.vue'
import extrascomp     from '@/components/extrascompv2.vue'
import navbarreserve  from '@/components/navbarreserve.vue'

import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name: 'Reservestep4',
    metaInfo: {
      title: "Enterprise Panama - Reserva 4 | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components: {
        masternav,
        mainfooter,
        maincontent,
        rents,
        covidnews,
        extrascomp,
        navbarreserve
    },
    mounted () {
      if(this.procesoReserva == false && this.accion_modificar == false)
      {
        this.$router.push({path:'/'})
      }
    },
    computed: {
      //...mapState('reserva', ['data', 'sucursales', 'auto', 'procesoReserva']),// borrar luego
      ...mapState('reservav2', ['data','detalles', 'auto', 'calculo', 'sucursales','procesoReserva', 'accion_modificar']),
      fecha_salida()
      {
        return moment(this.data.fecha_retiro).format('D MMMM YYYY')
      },
      fecha_entrega()
      {
        return moment(this.data.fecha_devolucion).format('D MMMM YYYY')
      },
      hora_salida()
      {
        return moment(this.data.hora_retiro, "h:mm A").format('LT')
      },
      hora_entrega()
      {
        return moment(this.data.hora_devolucion, "h:mm A").format('LT')
      },
      sucursal_salida()
      {
        return this.sucursales.find(sucursal => sucursal.id == this.data.sucursal_retiro)
      },
      sucursal_entrega()
      {
        return this.sucursales.find(sucursal => sucursal.id == this.data.sucursal_devolucion)
      }
    },
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.stepscollapse{
  background-color: #f3f3f3; 
  color: #169a5a; 
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  height: 46px;
  line-height: normal;
  margin: 0px;
  padding: 12px;
  border: none;
  border-bottom: 2px #535353 !important;
}
.navbg{
    background-color: #f3f3f3;
}
.textcircle{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 11.5px;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14.5px;
    font-weight: 500 !important;
    margin: 0 !important;
    padding:0 !important;
    letter-spacing: 1.1px
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.titleterm{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 18px;
   margin-top: 15px;
   margin-left: 0px;
   font-weight: 500;
   color: #333333;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.titlenav{
   color: #333333; 
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 14px;
   font-weight: 700;
   height: 19px;
   line-height: normal;
   margin: 0px 0px 5px;
   padding: 0px;
   width: 297px;
   letter-spacing: 1px
}
</style>